var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2642 6.26074V9.4756C13.2642 9.4756 10.7931 9.66611 10.8328 11.934C10.8022 12.5278 10.9974 13.1113 11.379 13.5672C11.7607 14.0232 12.3006 14.318 12.8905 14.3924H18.8754C18.8754 14.3924 24.1901 14.4707 24.1132 20.4443C24.0483 25.3825 18.4996 25.739 18.4996 25.739V22.5241C18.4996 22.5241 20.8531 22.3322 20.931 20.2552C20.9672 19.917 20.9309 19.575 20.8245 19.2519C20.7181 18.9288 20.544 18.6321 20.314 18.3816C20.0839 18.1311 19.8031 17.9325 19.4902 17.799C19.1774 17.6656 18.8397 17.6003 18.4996 17.6077H12.7032C12.7032 17.6077 7.60704 17.1414 7.65265 11.934C7.69756 6.82561 12.3397 6.27092 13.2642 6.26074Z",
    fill: "#FF774B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.4f9ffad502eb31b96e55cfed6dc4c56e.svg";
export { ForwardRef as ReactComponent };